module.exports = __webpack_public_path__ + "img/LV.f84ccbae.png";